import React, { Component } from "react"

import { Col, Modal, ModalBody, Row } from "reactstrap"

import Echec from "./Echec"
import Success from './Success';
import "./Success.css"

  class ModalMessage extends Component {
    constructor(props) {
      super(props)
    
      this.state = {
        ok:"",

      }
    }

    componentDidMount() {
      
    }




  render (){
  const show =this.props.show
  const success=this.props.success
  const onCloseClick=this.props.onCloseClick

  
  const titre=this.props.titre
  const message=this.props.message
  const boutton=this.props.boutton
  const handleValidate = this.props.handleValidate

 

  return (
    <Modal id="card" isOpen={show} toggle={onCloseClick} centered={true}>
        {/* <div > */}
          {/* <div id='nn' class="animated fadeIn">
            <div id='upper-side'>
            
                <h3 id='status'>
                {titre}
              </h3>
            </div>
            <div id='lower-side'>
              <p id='message'>
                {message}
              </p>
              <a onClick={handleValidate} id="contBtn">{boutton}</a>
            </div> */}
          {/* </div> */}
        
     {/* <ModalBody className="py-3 px-5">     {this.state.ok} */}
      {
        
            success?<Success boutton={boutton} message={message} titre={titre} handleValidate={handleValidate}/>:
            <Echec message={message} handleValidate={handleValidate}/>
        
      }
      
      {/* </ModalBody>  */}
    </Modal>
  )
}


  }
export default ModalMessage
